import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

const dateFields = ["start_date", "end_date"]
const tagFields = ["topics", "sources"]

export const FeedFilterModel = new Record({
    title: "",
    approved: "",
    judge_moderation_status: "",
    start_date: null,
    end_date: null,
    topics: [],
    sources: [],
    language: "",
    has_source: "",
    publisher: "",
    source_publication_type: ""
})

export const updateFeedSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields,
        dateFields
    )
